import React from "react"
import styled from "styled-components"
import colors from '../../styles/colors'
import fonts from "../../fonts"
import Wrapper from "../grid/wrapper"
import Row from "../grid/row"
import Column from "../grid/column"
import ScrollAnimation from "react-animate-on-scroll"
import Video from "../video"
import breakpoints from "../../styles/breakpoints"

const Anchor = styled.div`
    display: block;
    position: relative;
    top: -60px;
    visibility: hidden;
`

const IntroText = styled.div`
    margin-bottom:20px;

    @media ${breakpoints.tablet} {
        margin-bottom:80px;
    }

    p{
      font-family: ${fonts.helvetica};
      font-weight: normal;
      font-size: 16px;
      line-height: 24px;
      color: ${colors.tertiaryDark};
    }
`
const introSection = () => {
    return ( 
        <section>
            <Anchor id="intro"/>
            <Wrapper>
                <Row>
                    <Column xs={10} align="center">
                        <IntroText>
                            <ScrollAnimation animateIn="fadeIn">
                                <p><strong>Roca</strong> merupakan perusahaan asal Spanyol yang bergerak dibidang sanitary dan perlengkapan kamar mandi. Roca telah hadir selama lebih dari 100 tahun dan telah menjadi pionir dalam mengembangkan teknologi berbasis hemat air dan ramah lingkungan. Desain, inovasi, dan ramah lingkungan, selalu menjadi nilai utama bagi Roca.</p>
                                <p>Masuk ke dalam kancah industri <em>sanitary</em> Indonesia ditahun 2017, Roca Indonesia menegaskan keberadaan Roca sebagai salah satu merek terpercaya di dunia yang memfokuskan diri pada segala
                                kebutuhan produk <em>sanitary</em>.</p>
                                <p>Roca Indonesia menyediakan berbagai macam kategori produk, mulai dari <em>vitreous china, faucets, bathtubs</em>, hingga aksesoris. Didukung dengan tim yang solid serta kinerja yang profesional, hal tersebut menjadi bekal bagi Roca Indonesia mencapai kesuksesannya di masa mendatang. Bagi Roca, pelayanan terdepan merupakan salah satu hal terpenting dalam keseluruhan proses.</p>
                            </ScrollAnimation>
                        </IntroText>
                    </Column>
                    <Column xs={12} align="center">
                      <ScrollAnimation animateIn="fadeIn">
                          <Video
                            videoSrcURL="https://www.youtube.com/embed/P_1fhi_G2Fo"
                            videoTitle="Roca Indonesia"
                          />
                      </ScrollAnimation>
                    </Column>
                </Row>
            </Wrapper>
        </section>
     )
}
export default introSection;